<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="12" md="8">
        <v-autocomplete
          v-model="entry.operationTypeId"
          v-bind="getObject('operationTypeId')"
          label="Tipo de Operação"
          :items="extraData.accountGlobalSharedContext.allOperationTypesForSeedPlotOperation"
          item-value="id"
          item-text="name"
          :disabled="readOnly || (isEdit && (entry.operationTypeId == 17 || entry.operationTypeId == 18))"
          @input="selectOperationType()"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.operationDate"
          v-bind="getObject('operationDate')"
          label="Data da Operação"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.operationType && (entry.operationType.kind =='fertilization' || entry.operationType.kind =='application')">
        <MultiSelect
          v-model="entry.cropLotIds"
          v-bind="getObject('cropLotIds')"
          label="Lotes"
          :items="cropLotsList"
          :loadingItems="cropLotsListLoading"
          itemSubText="additionalInfo"
          itemSecondSubText="secondAdditionalInfo"
          :maxLimit="null"
          :readOnly="readOnly"
        >
        </MultiSelect>
      </v-col>

      <v-col cols="12" class="">
        <ActivitiesIndex
          :activities="entry.activitiesAttributes"
          :readOnly="readOnly"
          :initialDate="entry.operationDate"
          :isEdit="isEdit"
        />
      </v-col>

      

      <v-col cols="12" class="" v-if="entry.operationType && (entry.operationType.kind == 'sowing' || entry.operationType.kind == 'seedling_sown' || entry.operationType.kind =='fertilization' || entry.operationType.kind =='application' || entry.operationType.kind == 'forage_planting')">
        <ConsumedItemsIndex
          :exitMovementItems="entry.exitMovementItemsAttributes"
          :seedPlotOperation="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.operationType && (entry.operationType.kind == 'allocate_seeds' || entry.operationType.kind == 'seedling_crop')">
        <ProducedProductsIndex
          :entryMovementItems="entry.entryMovementItemsAttributes"
          :seedPlotOperation="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
          :modelNameSingular="modelNameSingular"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.observation"
          v-bind="getObject('observation')"
          label="Observações"
          outlined
          :disabled="readOnly">
        </v-textarea>
      </v-col>

    </v-row>

  </v-form>
</template>

<script>

import DateField from "@shared_components/date_field.vue";
import ActivitiesIndex from "@models/activities/index.vue";
import ConsumedItemsIndex from "@models/consumed_items/index.vue";
import ProducedProductsIndex from "@models/produced_products/index.vue";
import BaseUtil from "@shared_components/base_util.vue";
import MultiSelect from "@shared_components/multi_select.vue";
import gql from 'graphql-tag';

export default {
  data() {
    return {
      entryAttributes: {},
      addressError: false,
      cropLotsList: [],
      cropLotsListLoading: false,
      pageLoading: false,      
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    planningOperation: {
      default: null,
      type: Object
    },
    isEdit: {
      type: Boolean,
      default: false
    },    
    modelNameSingular: {
      type: String,
      default: "Muda"
    },
    modelNamePlural: {
      type: String,
      default: "Mudas"
    },
    cropLotIds: {
      type: Array,
      default: ()=> new Array,
    }
  },
  components: {
    ActivitiesIndex: ActivitiesIndex,
    DateField: DateField,
    ConsumedItemsIndex: ConsumedItemsIndex,
    ProducedProductsIndex: ProducedProductsIndex,
    BaseUtil: BaseUtil,
    MultiSelect: MultiSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    this.selectOperationType();
  },
  mounted() {
  },
  watch: {    
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectOperationType: function(){
      this.entry.operationType = this.extraData.accountGlobalSharedContext.allOperationTypesForSeedPlotOperation.find(obj => obj.id == this.entry.operationTypeId);
      console.log("selected operation");
      this.cropLotsListLoading = true;
        this.$apollo
          .query({
            query: LOAD_ALL_CROP_LOTS_FOR_OPERATION_QUERY,
            fetchPolicy: "no-cache",
            variables: { 
              id: this.entry.id,            
            }
          })
          .then(response => {
            // console.log("response dos packaging", response);
            this.cropLotsList = response.data.accountContext.availableCropLotsForOperation.cropLots;
             this.cropLotsList.forEach(function(item){
               item.id = item.id+"";
             });
          })
          .catch(response => console.log(response))
          .finally(() => (this.cropLotsListLoading = false));

    },
  }
};


const LOAD_ALL_CROP_LOTS_FOR_OPERATION_QUERY = gql`
query($id: ID){
	accountContext{
    availableCropLotsForOperation(id: $id)
  }
}`;

</script>

<style scoped></style>
